// action types
import { createRequestTypes } from "../../utils";

export const FETCH_BREVO_CONTACTS = createRequestTypes("FETCH_BREVO_CONTACTS");

export const fetchBrevoContactsRequest = () =>
    ({ type: FETCH_BREVO_CONTACTS.REQUEST });

export const fetchBrevoContactsSuccess = (data) =>
    ({ type: FETCH_BREVO_CONTACTS.SUCCESS, payload: { data } });

export const fetchBrevoContactsFailure = (error) =>
    ({ type: FETCH_BREVO_CONTACTS.FAILURE, payload: { error } });